import React, { useState, useEffect } from 'react'

// Self-contained copy of Carrier's AdminDatePicker using plain Bootstrap classes.
const AdminDatePicker = ({ shipment, setAdminDate }) => {
    const isKwikTrip = shipment.client.id === 'kwiktrip'
    const isSleepcountry = shipment.client.id === 'sleepcountry'
    const isKwikTrip711 = shipment.consignee?.id === 'kwiktrip711'
    const requestedDeliveryDate = shipment.consignee?.dates?.requestedDeliveryDate?.slice(0, 10) || ''

    const [date, setDate] = useState(isKwikTrip ? requestedDeliveryDate : '')
    const [inputMinDate, setInputMinDate] = useState(new Date().toISOString().split('T')[0])

    useEffect(() => {
        if (isKwikTrip711 && requestedDeliveryDate) {
            setInputMinDate(requestedDeliveryDate)
        }
    }, [shipment]) // eslint-disable-line react-hooks/exhaustive-deps

    const showAdminMode = window.location.search.includes('adminMode=1337')

    if (!showAdminMode && !isKwikTrip && !isSleepcountry) return null

    return (
        <div className="alert alert-info mt-2 py-2 d-inline-block">
            <small className="d-block mb-1">Select an alternate date:</small>
            <div className="d-flex gap-2">
                <input
                    type="date"
                    min={inputMinDate}
                    className="form-control form-control-sm"
                    value={date}
                    onChange={e => setDate(e.target.value)}
                />
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setAdminDate(date)}
                >
                    Apply
                </button>
            </div>
        </div>
    )
}

export default AdminDatePicker
